import {TreeListViewEnum} from 'src/app/editor-interface/models/enums/TreeListView.enum';

export const isTreeListView = (entityToTest: unknown): entityToTest is TreeListViewEnum => {
  return (
    typeof entityToTest === 'string' &&
    Object.values<string>(TreeListViewEnum).includes(entityToTest)
  );
};
